import Vue from 'vue';
import { AuthPlugin } from '@/helpers/Auth';
import store from '@/store';

Vue.use(AuthPlugin, {
    store: store,
    routes: {
        homePage: {path: '/'},
        loginPage: {path: '/auth/login'},
        forbidden: {path: '/error/403'},
        notFound: {path: '/error/404'},
        changePassword: {name: 'core-account-password'}
    }
});
